// extracted by mini-css-extract-plugin
export default {"root":"spinner_root__iFCn5","lds-spinner":"spinner_lds-spinner__mXSXA"};